export default "public/custom_2.svg";